import { IGetAllAssistenciaCategoriaUseCase } from "../../../presentation/useCases/read/get_all_assistencia_categoria_use_case";
import { AssistenciaTecnicaCategoriaLista } from "../../models/assistencia_tecnica_categoria_lista";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetAllAssistenciaCategoriaUseCase
 */

export class GetAllAssistenciaCategoriaUseCase
  implements IGetAllAssistenciaCategoriaUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) {
  }

  async getAllAssistenciaCategoria(
    idAssistenciaTecnica: number | null,
  ): Promise<AssistenciaTecnicaCategoriaLista[]> {
    if (idAssistenciaTecnica === null) {
      throw new Error('ID da assistência técnica é obrigatório para buscar as categorias!');
    }

    const result = await this.repository.getAllAssistenciaCategoria(
      idAssistenciaTecnica,
    );

    return result;
  }
}
